/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

export type FaqListBlockElementModelContentType =
	(typeof FaqListBlockElementModelContentType)[keyof typeof FaqListBlockElementModelContentType];

export const FaqListBlockElementModelContentType = {
	faqListBlock: "faqListBlock",
} as const;
